import { createSlice } from '@reduxjs/toolkit'
import SuppliersServices from '../../services/suppliersServices';
import { useCurrentUserContext } from '../../context/currentUserContext';

const initialState = {
  suppliers: []
};

const suppliersSlice = createSlice({
  name: 'suppliers',
  initialState,
  reducers: {
    suppliersLoaded(state, action) {
      state.suppliers = action.payload;
    }
  },
})

export const { suppliersLoaded } = suppliersSlice.actions;

export default suppliersSlice.reducer;

export const fetchSuppliersList = (categoryID, availableSuppliers, userId) => async (dispatch) => { 
  
  try {
     let filters={name: "", vatCode: "", enabled: true, userID: userId, availableSuppliers: availableSuppliers};
    const respData = await SuppliersServices.getSuppliers(filters);
    if (respData.success) {
      const suppliersList = respData.responseObject.value.supplierListDTO;    

      if(suppliersList){
        const objectsArray = suppliersList.map((item) => ({ value: item.id, label: item.name, vatCode: item.vatCode }));
        dispatch(suppliersLoaded(objectsArray));
      }
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

